import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: 'What is Care Diary?',
    answer: 'Care Diary is an app designed for families caring for someone with dementia. It helps you stay connected, share updates, and coordinate care with your loved ones in one secure place.',
  },
  {
    question: 'How do I add a family member?',
    answer: 'The managing carer can invite family members via the admin dashboard. Simply enter their email address, and they will receive an invitation to join your care circle.',
  },
  {
    question: 'Is my data secure?',
    answer: 'Yes. Care Diary is fully GDPR compliant and uses encrypted storage to protect all your personal and medical information. Your privacy and security are our top priorities.',
  },
  {
    question: 'Can I use it on a tablet?',
    answer: 'Absolutely. Care Diary is optimized for tablets and large screens, making it easy and comfortable to use for carers and family members of all ages.',
  },
  {
    question: 'How does voice messaging work?',
    answer: 'You can record voice messages directly in the app. These messages will then appear on the patient display, allowing your loved one to hear familiar voices and feel connected even when you cannot be there in person.',
  },
  {
    question: "Who can see the patient's information?",
    answer: 'Only assigned carers and invited family members can view the patient\'s information. Access is carefully controlled to ensure that sensitive details remain private and secure.',
  },
];

export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 24, fontFamily: 'Arial, sans-serif' }}>
      <h1
        style={{
          fontSize: 28,
          color: '#3a6b8c',
          marginBottom: 8,
          textAlign: 'center',
        }}
      >
        Frequently Asked Questions
      </h1>
      <p
        style={{
          fontSize: 18,
          color: '#6b8fa3',
          textAlign: 'center',
          marginBottom: 32,
        }}
      >
        Find answers to common questions about Care Diary
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {faqItems.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              style={{
                backgroundColor: isOpen ? '#e8f4f0' : '#f7faf9',
                border: '1px solid #c8ddd6',
                borderRadius: 12,
                overflow: 'hidden',
                transition: 'background-color 0.2s ease',
              }}
            >
              <button
                onClick={() => handleToggle(index)}
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '18px 20px',
                  border: 'none',
                  backgroundColor: 'transparent',
                  cursor: 'pointer',
                  fontSize: 18,
                  fontWeight: 600,
                  color: '#2c5f4e',
                  textAlign: 'left',
                  fontFamily: 'Arial, sans-serif',
                  lineHeight: 1.4,
                }}
              >
                <span>{item.question}</span>
                <span
                  style={{
                    fontSize: 22,
                    color: '#6b9e8a',
                    marginLeft: 16,
                    flexShrink: 0,
                    transition: 'transform 0.2s ease',
                    transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                  }}
                >
                  +
                </span>
              </button>

              {isOpen && (
                <div
                  style={{
                    padding: '0 20px 18px 20px',
                    fontSize: 16,
                    color: '#4a6e5f',
                    lineHeight: 1.6,
                  }}
                >
                  {item.answer}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};